<div class="lang-selector">
	<div class="lang-selector__trigger" [class.lang-selector__trigger--open]="isOpen()">
		<dsy-button variant="link" shape="round" [label]="'Change language'" [attr.aria-haspopup]="'listbox'" [attr.aria-expanded]="ariaExpanded()" (click)="toggle()">
			<div class="lang-selector__button">
				<img class="lang-selector__flag" [src]="'assets/flags/' + selected().icon" alt="" width="20" height="14" />
				<span class="lang-selector__label">{{ selected().label }}</span>
				<dsy-icon class="lang-selector__chevron" name="chevron_right" size="13px" library="material"></dsy-icon>
			</div>
		</dsy-button>
	</div>

	<div class="lang-selector__panel" [class.lang-selector__panel--open]="isOpen()" role="listbox" id="language-dropdown">
		@for (c of countries; track c.key) {
		<button type="button" class="lang-selector__row" (click)="select(c.key)" [attr.aria-selected]="selected().key === c.key">
			<div class="lang-selector__row-left">
				<img class="lang-selector__flag" [src]="'assets/flags/' + c.icon" alt="" width="24" height="18" />
				<span class="lang-selector__text" [ngClass]="{'lang-selector__text--selected': selected().key === c.key}">
					{{ c.label }}
				</span>
			</div>
		</button>
		}
	</div>

	@if (isOpen()) {
	<div class="lang-selector__backdrop" (click)="close()"></div>
	}
</div>